import { useTranslation } from "react-i18next";
import { getTranslatedLabel } from "../../../utils/helpers";
import { Controller } from "react-hook-form";
import { useState } from "react";
import DatePicker from "react-datepicker";
import ButtonIcon from "../buttonIcon";
import moment from "moment";

const DatePickerInputRHF = (props: any) => {
  const { t } = useTranslation();

  const { formField, errors, control, setValue } = props;
  const label = getTranslatedLabel(formField.translations);

  const [calendarIsOpen, setCalendarIsOpen] = useState(false);

  const handleCalenderPicker = () => setCalendarIsOpen(!calendarIsOpen);

  /**
   * get max date.
   */
  const getMaxDate = () => {
    return formField?.notSetFutureDates ? moment().toDate() : null;
  };

  /**
   * get min date.
   */
  const getMinDate = () => {
    return formField?.minDate ? moment(formField?.minDate).toDate() : null;
  };

  /**
   * manually handling date selection (minDate, maxDate) for survey forms.
   * Fields: compilation_date, data_somministrazione
   */
  const { minDate, maxDate, onChangeDate } = props.extraProps;
  const handleDateChange = (name: string, date: any) => {
    onChangeDate &&
      onChangeDate(date ? moment(date).format("YYYY-MM-DD") : null, name);
  };

  return (
    <>
      <div className="datepicker mb-2">
        <div
          className={`date-field DatePickerInput w-100 mt-0 ms-0 d-flex align-item-center justify-content-center input`}
        >
          <Controller
            name={formField.name}
            control={control}
            render={({ field }) => (
              <>
                <DatePicker
                  open={calendarIsOpen}
                  maxDate={maxDate || getMaxDate()}
                  minDate={minDate || getMinDate()}
                  name={formField.name}
                  placeholderText="DD/MM/YYYY"
                  dateFormat="dd/MM/yyyy"
                  selected={
                    field.value
                      ? moment(field.value, "YYYY-MM-DD").toDate()
                      : null
                  }
                  onChange={(date: Date) => {
                    field.onChange(moment(date).format("YYYY-MM-DD"));
                    handleDateChange(
                      formField.name,
                      moment(date).format("YYYY-MM-DD")
                    );
                    handleCalenderPicker();
                  }}
                  onFocus={() => handleCalenderPicker()}
                  onBlur={() => handleCalenderPicker()}
                  autoComplete="off"
                />
                {field.value ? (
                  <ButtonIcon
                    handleClick={() => {
                      setValue(formField.name, null);
                      handleDateChange(formField.name, null);
                    }}
                    icon="close"
                  />
                ) : (
                  <div className="downBox">
                    <ButtonIcon
                      disabled={false}
                      icon="calendar_month"
                      handleClick={(e: any) => (
                        handleCalenderPicker(), e.preventDefault()
                      )}
                    />
                  </div>
                )}
              </>
            )}
          />
        </div>

        {errors[formField.name] && (
          <div className="validation-errors-text-size text-danger mt-1 ms-2">
            {t("dynamic-form.required", { param: label })}
          </div>
        )}
      </div>
    </>
  );
};

export default DatePickerInputRHF;
